import Vue from 'vue'

import store from '@/store';
import VueRouter from 'vue-router';
import routes from './routes';
// import Log from 'laravel-mix/src/Log';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes,
	scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash,
				offset: { x: 0, y: 20 }
      }
    }
  },
});

router.beforeEach((to, from, next) => {
	// store.commit('shared/SET_ROUTE', to);
	if (!store.getters['auth/isAuthenticated'] && to.name !== 'login') next({ name: 'login' });
	else next();
});

export default router;